<app-genesys-chat-message-list [conversationId]="conversationId"
                               [contact]="contact"
                               [isMessagingPeriodEnded]="isMessagingPeriodEnded"
                               (imageLoad)="onImageLoad()"
                               #messageList
></app-genesys-chat-message-list>
